import { defineMessages } from '@cookbook/solid-intl'

/**
 * Currency picker copy (TENANT-5645). Labels are keyed by ISO 4217 code so
 * `currency-config.js` resolves each option's label from its code.
 */
export const messages = defineMessages({
    CAD: {
        defaultMessage: 'Canadian dollar',
        id: 'CurrencyConfig.currencyLabelCAD',
    },
    MXN: {
        defaultMessage: 'Mexican peso',
        id: 'CurrencyConfig.currencyLabelMXN',
    },
    USD: {
        defaultMessage: 'US dollar',
        id: 'CurrencyConfig.currencyLabelUSD',
    },
    optionSublabel: {
        defaultMessage: '{code} • {symbol}',
        id: 'CurrencyConfig.optionSublabel',
    },
})
